export default {
  in: '0.15s ease-in',
  out: '0.15s ease-out',
  slow: {
    in: '0.3s ease-in',
    out: '0.3s ease-out',
  },
  duration: '0.15s',
};
